if (document.getElementById('news__year')) {

    $(function () {
        let total = $('#total').val();
        // console.log(total);
        let page = 2;
        let year = $('#paramYear').val();
        let params = $('#paramFilters').val();

        $('#loadMore').click (function (e) {
            e.preventDefault();
            document.getElementById('loading').style.display = 'block';

            let queryUrl = "/news/p"+page;
            if (year != '' && params != '') {
                queryUrl += '?y=' + year + '&f=' + params;
            } else if (year != '') {
                queryUrl += '?y=' + year;
            } else if (params != '') {
                queryUrl += '?f=' + params;
            }
            // console.log(queryUrl);
            $.get( queryUrl, function( data ) {
                $( "#news-entries" ).append( data );
                document.getElementById('loading').style.display = 'none';
                const nextArticle = (page - 1) * 10;
                document.getElementsByClassName('editorial__teaser-link')[nextArticle].focus();
                page++;

                if (page > total) {
                    // console.log(page);
                    document.getElementById('loadMore').style.display = 'none';
                } else {
                    document.getElementById('loadMore').style.display = 'inline';
                }
            });
        });

        $('#news__filter-button').click (function (e) {
            e.preventDefault();
            params = '';
            year = '';
            
            if ($( "#news__year select" ).val() != 'Year') {
                year = $( "#news__year select" ).val();
            }
            // console.log(year);
            const checkboxes = Array.from(document.getElementsByClassName('news__checkbox'));
            // console.log(checkboxes);
            checkboxes.map((c, key) => {
                if (c.getElementsByTagName('input')[0].checked) {
                    const param = c.getAttribute('name');
                    params = params + param + ',';
                }
            });
            params = params != '' ? params.substring(0,params.length-1) : '';
            // console.log(params);
            if (params != '' && $( "#news__year select" ).val() != 'Year') {
                $.get( "/news?y="+year+"&f="+params, function( data ) {
                    $( "#news-entries" ).empty();
                    $( "#news-entries" ).append( data );

                    total = $('#total').val();
                    if (total <= 1) {
                        document.getElementById('loadMore').style.display = 'none';
                    } else {
                        document.getElementById('loadMore').style.display = 'inline';
                    }
                });
                // console.log(params);
            } else if (params != '') {
                $.get( "/news?f="+params, function( data ) {
                    $( "#news-entries" ).empty();
                    $( "#news-entries" ).append( data );

                    total = $('#total').val();

                    if (total <= 1) {
                        document.getElementById('loadMore').style.display = 'none';
                    } else {
                        document.getElementById('loadMore').style.display = 'inline';
                    }
                });
                // console.log(params);
            } else if ($( "#news__year select" ).val() != 'Year') {
                $.get( "/news?y="+year, function( data ) {
                    $( "#news-entries" ).empty();
                    $( "#news-entries" ).append( data );
                    // console.log(year);
                    total = $('#total').val();
                    if (total <= 1) {
                        document.getElementById('loadMore').style.display = 'none';
                    } else {
                        document.getElementById('loadMore').style.display = 'inline';
                    }
                });
                // console.log(year);
            } else {
                $.get( "/news", function( data ) {
                    $( "#news-entries" ).empty();
                    $( "#news-entries" ).append( data );

                    total = $('#total').val();
                    if (total <= 1) {
                        document.getElementById('loadMore').style.display = 'none';
                    } else {
                        document.getElementById('loadMore').style.display = 'inline';
                    }
                });
                // console.log(params);
            }
            
            if (window.innerWidth <= 960) {
                $('.news__right').removeClass('active');
                const resultsHeight = $('.news__main').offset().top - 80;
                window.scrollTo(0, resultsHeight);
            }
        });


        const icon = document.getElementsByClassName('news__mobile-icon')[0];
        const filterArea = document.getElementsByClassName('news__right')[0];
        // console.log( filterArea.classList );
        icon.addEventListener('click', () => {
            if (filterArea.classList.contains('active')) {
                filterArea.classList.remove('active');
                icon.setAttribute('aria-expanded', 'false');
            } else {
                filterArea.classList.add('active');
                icon.setAttribute('aria-expanded', 'true');
            }
        });
        icon.addEventListener('keypress', (e) => {
            if (e.charCode == 13) {
                if (filterArea.classList.contains('active')) {
                    filterArea.classList.remove('active');
                    icon.setAttribute('aria-expanded', 'false');
                } else {
                    filterArea.classList.add('active');
                    icon.setAttribute('aria-expanded', 'true');
                }
            }
        });

    });

}
